import { useGLTF } from "@react-three/drei"
import { Suspense, useEffect, useRef } from "react";
import * as THREE from "three";


const LoadModel = ({
    name,
    url,
    visible,
    rotation = [0, 0, 0]
}) => {
    const model = useGLTF(url);
    const groupRef = useRef();

    useEffect(() => {
        if (name === 'SATELLITE_TR' && model.scene) {
            model.scene.traverse((child) => {
                if (child.isMesh && child.material) {
                    // Handle both array and single material
                    if (Array.isArray(child.material)) {
                        child.material.forEach(mat => {
                            mat.transparent = true;
                            mat.opacity = 0.4;
                            mat.needsUpdate = true;
                        });
                    } else {
                        child.material.transparent = true;
                        child.material.opacity = 0.4;
                        child.material.needsUpdate = true;
                    }
                }
            });
        }
    }, [model, name]);

    return (
        <Suspense fallback={null} key={name}>
            {visible &&
                <group ref={groupRef} rotation={rotation}>
                    <primitive object={model.scene} />
                </group>
            }
        </Suspense>
    );
}

export default LoadModel